<ng-content select="[before]"></ng-content>

<color-presets-component 
    direction="down"
    [columns]="columnsCount"
    [(color)]="control().value" 
    [colorPresets]="control().presets" />

<ng-content></ng-content>